import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import { useAmazonStatus } from '../../hooks/useAmazonStatus';

const ClosedAccountGuard = ({ children }) => {
  const { user, token } = useContext(AuthContext);
  const { connected: amazonConnected, loading } = useAmazonStatus(token);

  if (loading) return null;

  if (user?.account_type === 'close' && !amazonConnected) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ClosedAccountGuard;
